import { gql } from "@apollo/client";
import { API } from "api/API";
import axiosInstance from "api/axiosInstance";
import { AxiosProgressEvent } from "axios";
const APIInstance = new API();

export const getMills = gql`
    query getMills {
        mill {
            mill_id
            name
            corporate_id
            division_id
            region_id
        }
    }
`;

export const getRCALibrary = gql`
    query getRCALibrary($limit: Int!, $offset: Int!, $order_by: [rca_order_by!], $where: rca_bool_exp) {
        rca(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
            rca_id
            mill_id
            created_by
            meeting_type_id
            display_number
            rca_type {
                rca_type_id
                name
            }
            incident_description
            key_success_factor {
                key_success_factors_id
                name
            }
            due_date
            date_held
            owner {
                user_id
                first_name
                last_name
                media {
                    media_id
                    media_url
                    media_type
                }
            }
            status {
                status_id
                name
                order
                default_status_translations {
                    status_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
            }
            rca_event_reports {
                event_report {
                    failure_type {
                        failure_type_id
                        name
                    }
                    functional_location {
                        functional_location_id
                        translation {
                            id
                            translation_names {
                                name
                                language_id
                            }
                        }
                    }
                    shift_day {
                        shift_historic {
                            shift {
                                shift_id
                                name
                            }
                        }
                    }
                    machine_center {
                        machine_center_id
                        name
                        mill_id
                        production_line {
                            production_line_id
                            name
                        }
                    }
                }
            }
            rca_detail {
                id
                production_line {
                    production_line_id
                    name
                }
                machine_center {
                    machine_center_id
                    name
                    short_name
                }
                functional_location {
                    functional_location_id
                    translation {
                        id
                        translation_names {
                            name
                            language_id
                        }
                    }
                }
                shift {
                    shift_id
                    name
                }
                failure_type {
                    failure_type_id
                    name
                    default_failure_type_translations {
                        failure_type_id
                        language {
                            language_id
                            name
                        }
                        translated_name
                    }
                }
                failure_code {
                    failure_code_id
                    name
                    default_failure_code_translations {
                        failure_code_id
                        language {
                            language_id
                            name
                        }
                        translated_name
                    }
                }
                secondary_failure_code {
                    failure_code_id
                    name
                    default_failure_code_translations {
                        failure_code_id
                        language {
                            language_id
                            name
                        }
                        translated_name
                    }
                }
            }
            action_plans {
                action_plan_id
                display_number
                description
                due_date
                status {
                    status_id
                    name
                    default_status_translations {
                        status_id
                        language {
                            language_id
                            name
                            code
                        }
                        translated_name
                    }
                }
                priority {
                    priority_id
                    name
                    default_priority_translations {
                        priority_id
                        language {
                            language_id
                            name
                            code
                        }
                        translated_name
                    }
                }
                submitted_by {
                    user_id
                    first_name
                    last_name
                    media {
                        media_id
                        media_url
                        media_type
                    }
                }
                assignee {
                    user_id
                    first_name
                    last_name
                    media {
                        media_id
                        media_url
                        media_type
                    }
                }
            }
            five_why_analyses {
                five_why_analysis_id
                problem_statement
                root_cause_conclusion
                why {
                    why_id
                    primary_why_id
                    text
                }
            }
        }
    }
`;

export const getRCAHistoricChangesLog = gql`
    query getRCAHistoricChangesLog($id: Int) {
        rca_history_log(where: { rca_id: { _eq: $id } }, order_by: { changed_at: desc }) {
            history_id
            field_name
            new_value
            old_value
            changed_at
            change_type
            user {
                first_name
                last_name
                media {
                    media_url
                }
            }
            action_plan_id
            action_plan {
                display_number
            }
        }
    }
`;

export const getRCALibraryCount = gql`
    query getRCALibraryCount($where: rca_bool_exp) {
        rca_aggregate(where: $where) {
            aggregate {
                count
            }
        }
    }
`;

export const getRCA = gql`
    query getRCA($rca_id: Int!) {
        rca(where: { rca_id: { _eq: $rca_id } }) {
            rca_id
            mill_id
            display_number
            corrective_work_order_number
            created_by
            meeting_type_id
            key_performance_indicator {
                key_performance_indicators_id
                name
            }
            key_success_factor {
                key_success_factors_id
                name
                default_key_success_factor_translations {
                    key_success_factor_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
            }
            rca_team_members {
                rca_team_member_id
                user {
                    user_id
                    first_name
                    last_name
                }
            }

            rca_type {
                rca_type_id
                name
            }

            rca_detail {
                id
                production_line {
                    production_line_id
                    name
                }
                machine_center {
                    machine_center_id
                    name
                    short_name
                }
                functional_location {
                    functional_location_id
                    translation {
                        id
                        translation_names {
                            name
                            language_id
                        }
                    }
                }
                shift {
                    shift_id
                    name
                }
                failure_type {
                    failure_type_id
                    name
                    default_failure_type_translations {
                        failure_type_id
                        language {
                            language_id
                            name
                        }
                        translated_name
                    }
                }
                failure_code {
                    failure_code_id
                    name
                    default_failure_code_translations {
                        failure_code_id
                        language {
                            language_id
                            name
                        }
                        translated_name
                    }
                }
                secondary_failure_code {
                    failure_code_id
                    name
                    default_failure_code_translations {
                        failure_code_id
                        language {
                            language_id
                            name
                        }
                        translated_name
                    }
                }
            }

            rca_event_reports {
                event_report {
                    event_report_id
                    valid_time
                    start_date
                    end_date
                    notes
                    shift_day {
                        shift_day_id
                        shift_historic {
                            shift_historic_id
                            shift {
                                shift_id
                                name
                            }
                        }
                    }
                    secondary_failure_code {
                        failure_code_id
                        name
                        default_failure_code_translations {
                            failure_code_id
                            language {
                                language_id
                                name
                            }
                            translated_name
                        }
                    }
                    failure_code {
                        failure_code_id
                        name
                        default_failure_code_translations {
                            failure_code_id
                            language {
                                language_id
                                name
                            }
                            translated_name
                        }
                    }
                    functional_location {
                        functional_location_id
                        translation {
                            id
                            translation_names {
                                name
                                language_id
                            }
                        }
                    }
                    machine_center {
                        machine_center_id
                        name
                        short_name
                        production_line {
                            production_line_id
                            name
                        }
                    }
                    user_operator {
                        user_id
                        last_name
                        first_name
                    }
                }
            }

            owner {
                user_id
                first_name
                last_name
            }
            rca_settings_id
            rca_setting {
                failure_type_id
                failure_type {
                    failure_type_id
                    name
                    default_failure_type_translations {
                        failure_type_id
                        language {
                            language_id
                            name
                        }
                        translated_name
                    }
                }
                rca_frequency_trigger {
                    rca_frequency_trigger_unit_id
                }
            }
            rca_type_id
            status {
                status_id
                name
                default_status_translations {
                    status_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
            }
            incident_description
            notes
            rca_conclusions
            created_at
            date_held
            incident_date
            action_plans(order_by: { created_at: desc }) {
                action_plan_id
                display_number
                name
                description
                due_date
                status {
                    status_id
                    name
                    default_status_translations {
                        status_id
                        language {
                            language_id
                            name
                            code
                        }
                        translated_name
                    }
                }
                priority {
                    priority_id
                    name
                    default_priority_translations {
                        priority_id
                        language {
                            language_id
                            name
                            code
                        }
                        translated_name
                    }
                }
                submitted_by {
                    user_id
                    first_name
                    last_name
                    media {
                        media_id
                        media_url
                        media_type
                    }
                }
                assignee {
                    user_id
                    first_name
                    last_name
                    media {
                        media_id
                        media_url
                        media_type
                    }
                }
            }
            rca_observations(order_by: { created_at: desc }) {
                rca_observation_id
                description
                date
                created_at
                user {
                    user_id
                    first_name
                    last_name
                    media {
                        media_id
                        media_url
                        media_type
                    }
                }
            }
            five_why_analyses {
                five_why_analysis_id
                problem_statement
                root_cause_conclusion
                media {
                    name
                    media_id
                    media_url
                    media_type
                }
                why(where: { deleted_at: { _is_null: true } }) {
                    why_id
                    primary_why_id
                    text
                }
            }
            rca_media(where: { media: { is_enabled: { _eq: true } }, deleted_at: { _is_null: true } }) {
                rca_media_id
                rca_id
                media {
                    name
                    media_id
                    media_type
                    media_url
                    is_enabled
                }
            }
            fishbone_diagram {
                problem_statement
                fishbone_diagram_id
                rca_id
                fishbone_diagram_problem_causes(
                    where: { deleted_at: { _is_null: true } }
                    order_by: { created_at: desc }
                ) {
                    deleted_at
                    fishbone_diagram_id
                    fishbone_diagram_problem_cause_id
                    is_highlighted
                    primary_problem_cause_id
                    fishbone_diagram_category {
                        fishbone_diagram_category_id
                        name
                    }
                    description
                }
            }
            deleted_at
            due_date
            updated_at
        }
    }
`;

export const upsertRCAWithTeamMembers = gql`
    mutation upsertRCAWithTeamMembers(
        $rcaId: Int!
        $rcaChanges: rca_set_input!
        $rca_team_members: [rca_team_member_insert_input!]!
    ) {
        update_rca(where: { rca_id: { _eq: $rcaId } }, _set: $rcaChanges) {
            affected_rows
        }
        insert_rca_team_member(
            objects: $rca_team_members
            on_conflict: { constraint: rca_team_member_pkey, update_columns: [user_id] }
        ) {
            affected_rows
        }
    }
`;

export const upsertRCA5WhyAnalysis = gql`
    mutation upsertRCA5WhyAnalysis($five_why_analysis: [five_why_analysis_insert_input!]!, $why: [why_insert_input!]!) {
        insert_five_why_analysis(
            objects: $five_why_analysis
            on_conflict: {
                constraint: five_why_analysis_pkey
                update_columns: [problem_statement, root_cause_conclusion]
            }
        ) {
            affected_rows
            returning {
                five_why_analysis_id
            }
        }
        insert_why(objects: $why, on_conflict: { constraint: why_pkey, update_columns: [text, deleted_at] }) {
            affected_rows
        }
    }
`;

export const upsertRCA5WhyAnalysisItemQuery = gql`
    mutation upsertRCA5WhyAnalysisItemQuery($why: [why_insert_input!]!) {
        insert_why(objects: $why, on_conflict: { constraint: why_pkey, update_columns: [] }) {
            affected_rows
            returning {
                why_id
            }
        }
    }
`;

export const getFishboneCategories = gql`
    query GetFishboneDiagramCategory {
        fishbone_diagram_category {
            name
            fishbone_diagram_category_id
        }
    }
`;

export const upsertFishboneDiagram = gql`
    mutation upsertFishboneDiagram($fishbone_diagram: [fishbone_diagram_insert_input!]!) {
        insert_fishbone_diagram(
            objects: $fishbone_diagram
            on_conflict: { constraint: fishbone_diagram_pkey, update_columns: [problem_statement] }
        ) {
            affected_rows
            returning {
                fishbone_diagram_id
            }
        }
    }
`;

export const upsertFishboneDiagramProblemCause = gql`
    mutation upsertFishboneDiagramProblemCause(
        $fishbone_diagram_problem_cause: [fishbone_diagram_problem_cause_insert_input!]!
    ) {
        insert_fishbone_diagram_problem_cause(
            objects: $fishbone_diagram_problem_cause
            on_conflict: {
                constraint: fishbone_diagram_problem_cause_pkey
                update_columns: [description, deleted_at, primary_problem_cause_id, is_highlighted]
            }
        ) {
            affected_rows
            returning {
                fishbone_diagram_category_id
            }
        }
    }
`;

export const uploadFiveWhyAnalysisFiles = async (
    fiveWhyAnalysisId: number,
    userImageFormData: FormData,
    onUploadProgress: (progressEvent: AxiosProgressEvent) => void,
): Promise<{ publicUrl: string } | unknown> => {
    try {
        const url = `${APIInstance.api_root}/upload/five-why-analysis-media/${fiveWhyAnalysisId}`;
        const response = await axiosInstance.put<{ publicUrl: string }>(url, userImageFormData, { onUploadProgress });

        return response;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const uploadRcaFiles = async (
    rcaId: number,
    userImageFormData: FormData,
    onUploadProgress: (progressEvent: AxiosProgressEvent) => void,
): Promise<{ publicUrl: string } | unknown> => {
    try {
        const url = `${APIInstance.api_root}/upload/rca-media/${rcaId}`;
        const response = await axiosInstance.put<{ publicUrl: string }>(url, userImageFormData, { onUploadProgress });

        return response;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const updateFiveWhyAnalysisMediaQuery = gql`
    mutation UpdateFiveWhyAnalysisMedia($five_why_analysis_id: Int!, $media_id: Int!) {
        update_media(where: { media_id: { _eq: $media_id } }, _set: { is_enabled: false }) {
            affected_rows
        }
        update_five_why_analysis(
            where: { five_why_analysis_id: { _eq: $five_why_analysis_id } }
            _set: { media_id: null }
        ) {
            affected_rows
        }
    }
`;

export const insertObservationRCA = gql`
    mutation insertObservationRCA($observationRCA: [rca_observation_insert_input!]!) {
        insert_rca_observation(objects: $observationRCA) {
            returning {
                rca_observation_id
            }
        }
    }
`;

export const getLastSevenDaysDowntimeLengthByType = gql`
    query getLastSevenDaysDowntimeLengthByType($where: event_report_bool_exp) {
        event_report(where: $where) {
            event_report_id
            valid_time
        }
    }
`;

export const updateRCAMedia = gql`
    mutation updateRCAMedia($rcaMediaId: Int!, $changes: rca_media_set_input!) {
        update_rca_media(where: { rca_media_id: { _eq: $rcaMediaId } }, _set: $changes) {
            affected_rows
            returning {
                rca_media_id
            }
        }
    }
`;

export const getProductionLineOptions = gql`
    query getProductionLineOptions($where: production_line_bool_exp) {
        production_line(where: $where) {
            production_line_id
            name
        }
    }
`;

export const getMachineCenterOptions = gql`
    query getMachineCenterOptions($where: machine_center_bool_exp) {
        machine_center(where: $where) {
            machine_center_id
            name
        }
    }
`;

export const getFunctionalLocationOptions = gql`
    query getFunctionalLocationOptions($where: functional_location_bool_exp) {
        functional_location(where: $where) {
            functional_location_id
            translation {
                id
                translation_names {
                    name
                    language_id
                }
            }
            area {
                area_id
                translation {
                    id
                    translation_names {
                        name
                        language_id
                    }
                }
            }
        }
    }
`;

export const getFailureTypeOptions = gql`
    query getFailureTypeOptions($where: failure_type_bool_exp) {
        failure_type(where: $where) {
            failure_type_id
            name
            default_failure_type_translations {
                failure_type_id
                language {
                    language_id
                    name
                }
                translated_name
            }
        }
    }
`;

export const getFailureCodeOptions = gql`
    query getFailureCodeOptions($where: failure_code_bool_exp) {
        failure_code(where: $where) {
            failure_code_id
            name
            default_failure_code_translations {
                failure_code_id
                language {
                    language_id
                    name
                }
                translated_name
            }
        }
    }
`;

export const getShiftOptions = gql`
    query getShiftOptions($where: shift_bool_exp) {
        shift(where: $where) {
            shift_id
            name
        }
    }
`;

export const upsertRCADetails = gql`
    mutation upsertManualRCAs($rca: rca_insert_input!, $rcaDetails: rca_details_insert_input!, $isUpdate: Boolean!) {
        insert_rca_one(
            object: $rca
            on_conflict: {
                constraint: rca_pkey
                update_columns: [due_date, owner_id, status_id, incident_description, meeting_type_id, incident_date]
            }
        ) {
            rca_id
        }

        insert_rca_details_one(
            object: $rcaDetails
            on_conflict: {
                constraint: rca_details_pkey
                update_columns: [
                    production_line_id
                    machine_center_id
                    functional_location_id
                    secondary_functional_location_id
                    failure_type_id
                    failure_code_id
                    secondary_failure_code_id
                    shift_id
                ]
            }
        ) @include(if: $isUpdate) {
            id
            rca_id
        }
    }
`;

export const getMeetingTypes = gql`
    query getMeetingTypes($where: meeting_type_bool_exp) {
        meeting_type(where: $where, order_by: { created_at: desc }) {
            id
            default_translation {
                id
                default_meeting_translation_names {
                    name
                    language_id
                }
            }
            translation {
                id
                translation_names {
                    name
                    language_id
                }
            }
        }
    }
`;

export const validateMeetingIsUsed = gql`
    query validateMeetingIsUsed($where: meeting_type_bool_exp) {
        meeting_type(where: $where) {
            action_plans(
                where: {
                    deleted_at: { _is_null: true }
                    _or: [{ issue: { deleted_at: { _is_null: true } } }, { rca: { deleted_at: { _is_null: true } } }]
                }
                limit: 1
            ) {
                action_plan_id
            }
            issues(where: { deleted_at: { _is_null: true } }, limit: 1) {
                issue_id
            }
            rcas(where: { deleted_at: { _is_null: true } }, limit: 1) {
                rca_id
            }
        }
    }
`;

export interface getValidateMeetingIsUsedReturn {
    meeting_type: {
        action_plans: {
            action_plan_id: number;
        }[];
        issues: {
            issue_id: number;
        }[];
        rcas: {
            rca_id: number;
        }[];
    }[];
}

export const insertMeetingType = gql`
    mutation insertMeetingType($meetingType: [meeting_type_insert_input!]!) {
        insert_meeting_type(
            objects: $meetingType
            on_conflict: { constraint: meeting_type_pkey, update_columns: [name_translation_id, deleted_at] }
        ) {
            affected_rows
            returning {
                id
            }
        }
    }
`;

export const updateMeetingType = gql`
    mutation updateMeetingType($id: Int!, $changes: meeting_type_set_input!) {
        update_meeting_type(where: { id: { _eq: $id } }, _set: $changes) {
            affected_rows
        }
    }
`;

export const deleteMeetingTypeAndUpdateRegistries = gql`
    mutation updateMeetingType($idDeleted: Int!, $replacementId: Int!, $meetingChanges: meeting_type_set_input!) {
        update_rca(
            where: { meeting_type_id: { _eq: $idDeleted }, deleted_at: { _is_null: true } }
            _set: { meeting_type_id: $replacementId }
        ) {
            affected_rows
            returning {
                rca_id
            }
        }
        update_issue(
            where: { meeting_type_id: { _eq: $idDeleted }, deleted_at: { _is_null: true } }
            _set: { meeting_type_id: $replacementId }
        ) {
            affected_rows
            returning {
                issue_id
            }
        }
        update_action_plan(
            where: { meeting_type_id: { _eq: $idDeleted }, deleted_at: { _is_null: true } }
            _set: { meeting_type_id: $replacementId }
        ) {
            affected_rows
            returning {
                action_plan_id
            }
        }
        update_meeting_type(where: { id: { _eq: $idDeleted } }, _set: $meetingChanges) {
            affected_rows
            returning {
                id
            }
        }
    }
`;

export interface getMeetingTypesReturn {
    meeting_type: {
        id: number;
        default_translation?: {
            id: number;
            default_meeting_translation_names: {
                name: string;
                language_id: number;
            }[];
        };
        translation?: {
            id: number;
            translation_names: {
                name: string;
                language_id: number;
            }[];
        };
    }[];
}
